import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { QRCodeModule } from 'angularx-qrcode';
import { StationStatusComponent } from './component/station-status.component';

@NgModule({
  declarations: [
    StationStatusComponent
  ],
  imports: [
    CommonModule,
    QRCodeModule,
    CommonTranslationModule,
    CommonUIModule
]
})
export class StationStatusModule { }
